import Modal from './modal'

let modals;

function modalTriggerClickHandler(e) {
  let trigger = e.currentTarget

  let modalId = trigger.getAttribute('href').replace(/^\#/, '')

  if (typeof modals[modalId] !== 'undefined') {
    e.preventDefault()
    modals[modalId].open(trigger)
    return;
  }

  console.warn('Modal not found for anchor', trigger)
}

export default {
  init: function() {
    document.addEventListener('DOMContentLoaded', () => {

      let modalElems = [...document.querySelectorAll('.modal')]

      modals = modalElems.reduce((map, modalElem) => {

        const modal = new Modal(modalElem, {
          ariaHideOnOpenSelectors: [
            'body > header',
            'body > footer',
            'body > main',
          ]
        })

        const modalId = modalElem.id

        let modalTriggers = [...document.querySelectorAll(`[href="#${ modalId }"]`)]
        modalTriggers.forEach((modalTrigger) => {
          modalTrigger.addEventListener('click', modalTriggerClickHandler)
        })

        map[modalId] = modal

        return map
      }, {})

      console.log(modals)

    })
  },

  getById: function(id) {
    return modals[id]
  },

  getAll: function() {
    return modals
  },

  closeAll: function() {
    Object.keys(modals).forEach((modalId) => {
      modals[modalId].close()
    })
  }
}

